import { PixelCrop } from 'react-image-crop';

interface DrawCroppedImageOptions {
  imgRef: React.RefObject<HTMLImageElement>;
  completedCrop?: PixelCrop;
  previewCanvasRef: React.RefObject<HTMLCanvasElement>;
}
export const drawCroppedImage = ({
  completedCrop,
  imgRef,
  previewCanvasRef,
}: DrawCroppedImageOptions) => {
  if (
    !(
      completedCrop &&
      previewCanvasRef.current &&
      imgRef.current &&
      completedCrop.width &&
      completedCrop.height
    )
  ) {
    return;
  }

  const image = imgRef.current;
  const canvas = previewCanvasRef.current;
  const crop = completedCrop;

  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  const ctx = canvas.getContext('2d');
  
  if (!ctx) return;

  canvas.width = crop.width;
  canvas.height = crop.height;

  ctx.clearRect(0, 0, canvas.width, canvas.height);

  // Make circle clip for preview
  ctx.save();
  ctx.beginPath();
  ctx.arc(crop.width / 2, crop.height / 2, crop.width / 2, 0, 2 * Math.PI);
  ctx.clip();

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );

  ctx.restore();
};
